import { SupportedLanguage } from '@foundation/localization';

import { TwoCTwoPLocale } from './schemas/TwoCTwoPLocale';

export const TwoCTwoPSupportedLocale: {
  [key in SupportedLanguage]: TwoCTwoPLocale;
} = {
  [SupportedLanguage.Bulgarian]: 'en',
  [SupportedLanguage.Czech]: 'en',
  [SupportedLanguage.ChineseSimplifiedChina]: 'zh-cn',
  [SupportedLanguage.ChineseTraditionalHongKong]: 'zh-cn',
  [SupportedLanguage.Danish]: 'en',
  [SupportedLanguage.Dutch]: 'en',
  [SupportedLanguage.English]: 'en',
  [SupportedLanguage.Finnish]: 'en',
  [SupportedLanguage.French]: 'fr',
  [SupportedLanguage.German]: 'de',
  [SupportedLanguage.Hungarian]: 'en',
  [SupportedLanguage.Indonesian]: 'id',
  [SupportedLanguage.Italian]: 'it',
  [SupportedLanguage.Japanese]: 'ja',
  [SupportedLanguage.Korean]: 'ko',
  [SupportedLanguage.Norwegian]: 'en',
  [SupportedLanguage.Polish]: 'en',
  [SupportedLanguage.Portuguese]: 'pt',
  [SupportedLanguage.Russian]: 'ru',
  [SupportedLanguage.Spanish]: 'es',
  [SupportedLanguage.Swedish]: 'en',
  [SupportedLanguage.Thai]: 'th',
  [SupportedLanguage.Turkish]: 'en',
  [SupportedLanguage.Ukrainian]: 'en',
  [SupportedLanguage.Vietnamese]: 'en',
  [SupportedLanguage.Icelandic]: 'en',
  [SupportedLanguage.Lithuanian]: 'en',
  [SupportedLanguage.Romanian]: 'en',
  [SupportedLanguage.Estonian]: 'en',
  [SupportedLanguage.Malaysian]: 'en',
  [SupportedLanguage.Latvian]: 'en',
  [SupportedLanguage.ChineseTraditionalTaiwan]: 'zh-tw',
};
